import { formatDistanceToNow, format, isToday, isYesterday } from 'date-fns';

function toDate(timestamp?: string | Date) {
  if (!timestamp) {
    return new Date();
  }

  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return Number.isNaN(date.getTime()) ? new Date() : date;
}

export function formatMessageTime(timestamp?: string | Date, _nowInput?: Date | number) {
  const date = toDate(timestamp);

  if (isToday(date)) {
    return formatDistanceToNow(date, { addSuffix: true });
  }

  if (isYesterday(date)) {
    return `Yesterday at ${format(date, 'h:mm a')}`;
  }

  return format(date, "MMM d 'at' h:mm a");
}

export function formatAbsoluteMessageTime(timestamp?: string | Date) {
  return format(toDate(timestamp), 'MMM d, yyyy, h:mm:ss a zzz');
}
